export class ChangePassword {
    claveActual : string;
    claveActualAnterior : string;
    confirmarClave : string;
    confirmarClaveAnterior : string;
    nuevaClave : string;
    nuevaClaveAnterior : string;
    userId: number;

    cambioCorrecto: boolean;
    mensajeCambio: string;

    constructor(json? : any) {
        if (json != null) {
            this.claveActual = json.claveActual;
            this.claveActualAnterior = json.claveActualAnterior;
            this.nuevaClave = json.nuevaClave;
            this.nuevaClaveAnterior = json.nuevaClaveAnterior;
            this.confirmarClave = json.confirmarClave;   
            this.confirmarClaveAnterior = json.confirmarClaveAnterior;         
            this.userId = json.userId;

            this.cambioCorrecto = json.cambioCorrecto;
            this.mensajeCambio = json.mensajeCambio;
        }
    }    
}


// WEBPACK FOOTER //
// ./src/app/shared/layout/header/change-password/changePassword.ts